import { permissionGroupHelper, UserToken } from '../amorg-common';

export type UserHomeDestination = 'user-overview' | 'articles' | 'dashboard';

export function getUserHomeDestination(user: UserToken): UserHomeDestination
{
    if(user.permissionGroupId === '')
        throw new Error("user must have a permission group to access the app");
    else if(user.permissionGroupId === 'anonymous')
        throw new Error("user cannot be anonymous");
    else if(user.permissionGroupId === 'employee')
        throw new Error("user cannot have employee permission group");

    if(!permissionGroupHelper.hasMinimumPermissionGroup(user.permissionGroupId, 'member'))
        return 'user-overview';

    if(user.features.includes('Articles') && user.features.includes('ArticleLandingPage'))
        return 'articles';

    return 'dashboard';
}
